export default function Arrowup() {
return(
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="63" viewBox="0 0 16 63" fill="none">
  <path d="M8.58406 1.13835C8.19353 0.747829 7.56037 0.747829 7.16984 1.13835L0.805883 7.50231C0.415359 7.89284 0.415359 8.526 0.805883 8.91653C1.19641 9.30705 1.82957 9.30705 2.2201 8.91653L7.87695 3.25967L13.5338 8.91653C13.9243 9.30705 14.5575 9.30705 14.948 8.91653C15.3385 8.526 15.3385 7.89284 14.948 7.50231L8.58406 1.13835ZM8.87695 62.0308L8.87695 1.84546L6.87695 1.84546L6.87695 62.0308L8.87695 62.0308Z" fill="black"/>
</svg>
)
}
